import React from "react";
import { Box } from "@mui/material";
import Section from "../ui/Section";
import Reveal from "../ui/Reveal";
import { Accent, Display, Label } from "../ui/Type";
import { DIFFERENTIATORS } from "../../data/process";
import { color, font, type } from "../../design/tokens";

/**
 * What actually separates us.
 *
 * Set as a numbered editorial list on ink, not as four icon cards. Every
 * contractor site has the icon cards, and the icons carry no information — a
 * hard hat above the words "quality workmanship" is decoration standing where
 * an argument should be.
 *
 * Each claim here is one the business can be held to and that the project
 * photography backs up: self-performed trades, permit handling, the work
 * behind the finish, and containment.
 */
const WhyUs = () => (
  <Section tone="ink">
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "0.85fr 1.15fr" },
        gap: { xs: 6, md: 10 },
        alignItems: "start",
      }}
    >
      <Box sx={{ position: { md: "sticky" }, top: { md: 140 } }}>
        <Label tone="onInk">Why Five Lights Reno</Label>
        <Display as="h2" size="lg" tone="onInk" sx={{ marginTop: 3 }}>
          Four things we'd want to know if we were{" "}
          <Accent sx={{ color: color.clayLight }}>hiring us</Accent>.
        </Display>
      </Box>

      <Box sx={{ borderTop: `1px solid ${color.lineOnInk}` }}>
        {DIFFERENTIATORS.map((item, index) => (
          <Reveal key={item.title} delay={index * 70}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "auto 1fr", md: "auto 1fr" },
                columnGap: { xs: 2.5, md: 5 },
                paddingBlock: { xs: 4, md: 5 },
                borderBottom: `1px solid ${color.lineOnInk}`,
              }}
            >
              <Box
                component="span"
                aria-hidden="true"
                sx={{ ...type.numeral, color: color.clayLight, paddingTop: 1 }}
              >
                {String(index + 1).padStart(2, "0")}
              </Box>
              <Box>
                <Box
                  component="h3"
                  sx={{
                    fontFamily: font.display,
                    fontSize: "clamp(1.35rem, 2.2vw, 1.75rem)",
                    lineHeight: 1.2,
                    color: color.onInk,
                    margin: 0,
                  }}
                >
                  {item.title}
                </Box>
                <Box
                  component="p"
                  sx={{ ...type.body, color: color.onInkMute, marginTop: 2, maxWidth: 560 }}
                >
                  {item.body}
                </Box>
              </Box>
            </Box>
          </Reveal>
        ))}
      </Box>
    </Box>
  </Section>
);

export default WhyUs;
